import React from 'react';

import cx from 'classnames';
import { Info, Sparkle } from 'phosphor-react';

import Icon from 'components/shared/Icon';
import ALetter from 'components/shared/Icon/icons/ALetter';
import Blocks from 'components/shared/Icon/icons/Blocks';
import Iframe from 'components/shared/Icon/icons/Iframe';
import Image from 'components/shared/Icon/icons/Image';
import NewPDF2 from 'components/shared/Icon/icons/NewPDF2';
import RowsPlusBottom from 'components/shared/Icon/icons/RowsPlusBottom';
import SectionBlock from 'components/shared/Icon/icons/SectionBlock';
import Video from 'components/shared/Icon/icons/Video';
import { ACCORDION_INITIAL_DATA } from 'constants/blocksMockData';

import s from './Scenes/BlocksMenu/index.module.css';
import { IGetMenuItemProps } from './types';

const BLOCK_TYPES = {
  SECTION: 'section',
  TEXT: 'text',
  IMAGES: 'image',
  VIDEO: 'embed',
  FAST_FACTS: 'list',
  PDF: 'document',
  BLOCK: 'block',
  IFRAME: 'iframe',
  AI: 'ai',
  ACCORDION: 'accordion',
};

export const getMenuItems = ({ handleClick, handleChangeScene, accordionDisabled }: IGetMenuItemProps) => [
  [
    {
      type: BLOCK_TYPES.SECTION,
      name: 'Section',
      iconComponent: <Icon component={SectionBlock} className={cx(s.itemIcon, s.imagesIcon)} />,
      onClick: () => {
        handleClick([
          {
            type: 'header',
            data: {
              subheadline: 'New Section',
            },
          },
          { type: 'text', data: {} },
        ]);
      },
    },
    {
      type: BLOCK_TYPES.TEXT,
      name: 'Text',
      iconComponent: <Icon component={ALetter} className={cx(s.itemIcon, s.textIcon)} />,
      onClick: () => handleClick({ type: 'text', data: {} }),
    },
    {
      type: BLOCK_TYPES.IMAGES,
      name: 'Images',
      iconComponent: <Icon component={Image} className={cx(s.itemIcon, s.imagesIcon)} />,
      onClick: () => handleClick({ type: 'image', data: {} }),
    },
    {
      type: BLOCK_TYPES.VIDEO,
      name: 'Video',
      iconComponent: <Icon component={Video} className={cx(s.itemIcon, s.videoIcon)} />,
      onClick: () => handleClick({ type: 'embed', data: {} }),
    },
    {
      type: BLOCK_TYPES.FAST_FACTS,
      name: 'Facts',
      iconComponent: <Icon component={Info} className={cx(s.itemIcon, s.infoCharIcon)} />,
      onClick: () => handleClick({ type: 'list', data: { items: [{ desc: { text: '' } }] } }),
    },
  ],
  [
    {
      type: BLOCK_TYPES.PDF,
      name: 'PDF',
      iconComponent: <Icon component={NewPDF2} className={cx(s.itemIcon, s.pdfIcon)} />,
      onClick: () => handleClick({ type: 'document', data: {} }),
    },
    {
      type: BLOCK_TYPES.BLOCK,
      name: 'Block',
      iconComponent: <Icon component={Blocks} className={cx(s.itemIcon, s.pdfIcon)} />,
      onClick: () => handleChangeScene(BLOCK_SCENES.CONTENT_BLOCK),
    },
    {
      type: BLOCK_TYPES.IFRAME,
      name: 'iFrame',
      iconComponent: <Icon component={Iframe} className={cx(s.itemIcon, s.pdfIcon)} />,
      onClick: () => handleChangeScene(BLOCK_SCENES.IFRAME_CONFIG),
    },
    {
      type: BLOCK_TYPES.ACCORDION,
      name: 'Accordion',
      iconComponent: <Icon component={RowsPlusBottom} className={cx(s.itemIcon, s.pdfIcon, s.phosporIcon)} />,
      onClick: () => handleClick(ACCORDION_INITIAL_DATA as any),
      disabled: accordionDisabled,
    },
    {
      type: BLOCK_TYPES.AI,
      name: 'AI',
      iconComponent: <Icon component={Sparkle} className={cx(s.itemIcon, s.pdfIcon, s.phosporIcon)} />,
      onClick: () => handleClick({ type: 'text', data: { initialEditor: 'ai-prompt' } as any }),
    },
  ],
];

export const BLOCK_SCENES = {
  DEFAULT: 'default',
  CONTENT_BLOCK: 'contentBlock',
  IFRAME_CONFIG: 'iframe',
};
